import { useEffect, useRef, useState } from "react";

import { COLLAPSED_HEIGHT, BLOCK_HEIGHT, BLOCK_SPACING } from "./events-calendar";

interface IProps {
	entry: any;
	isCollapsed: boolean;
}

const LiveTicker: React.FC<IProps> = ({ entry, isCollapsed }) => {
	const interval = useRef<NodeJS.Timeout>();
	const [position, setPosition] = useState(0);
	const [renderNull, setRenderNull] = useState(true);

	useEffect(() => {
		const run = () => {
			const blockDate = new Date(entry[0]);
			const currentDate = new Date();

			const currentHour = currentDate.getHours();
			const currentMonth = currentDate.getMonth();
			const currentYear = currentDate.getFullYear();
			const currentMinutes = currentDate.getMinutes();
			const currentDay = currentDate.getDate();

			const blockHour = blockDate.getHours();
			const blockMonth = blockDate.getMonth();
			const blockYear = blockDate.getFullYear();
			const blockDay = blockDate.getDate();

			if (
				currentHour !== blockHour ||
				currentMonth !== blockMonth ||
				currentYear !== blockYear ||
				currentDay !== blockDay
			) {
				setRenderNull(true);
				setPosition(0);
				return;
			}
			setRenderNull(false);
			const blockHeight = isCollapsed ? COLLAPSED_HEIGHT : BLOCK_HEIGHT + BLOCK_SPACING;
			const _position = currentMinutes * (blockHeight / 60);
			setPosition(_position);
		};

		run();

		interval.current = setInterval(() => {
			run();
		}, 1000 * 60);

		return () => {
			if (interval.current) {
				clearInterval(interval.current);
			}
		};
	}, [entry, isCollapsed]);

	if (renderNull) return null;
	return (
		<div
			className="live-ticker"
			style={{
				top: position + "px"
			}}
		></div>
	);
};

export default LiveTicker;
